.divider {
  margin-top: 16px;
  margin-bottom: 16px;
}

.chordsContainer {
  min-height: 50px;
}

.menuIcon {
  color: inherit;
}

.chordName {
  font-size: 2em;
}
